import React from 'react'

export default function AccountLegendPanel({ items }) {
  return (
    <div className="w-full md:w-[352px] shrink-0 bg-white border border-border-lines rounded-2xl p-4">
      <p className="text-base font-semibold text-dark-blue mb-2">LEGEND</p>

      <div className="flex flex-col">
        {
          items.map((item, index) => (
            <div
              key={item.label}
              className={`flex items-start gap-4 py-4 text-base ${index < items.length - 1 ? 'border-b border-border-lines' : ''}`}
            >
              <p className="w-[119px] shrink-0 text-secondary">{item.label}</p>
              <p className="text-dark-blue">{item.description}</p>
            </div>
          ))
        }
      </div>
    </div>
  )
}
